<template>
  <div class="modal fade" :id="id" tabindex="-1">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <form @submit.prevent="sendMail" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('mail.update_mail') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="loadForm">
                <span class="svg-icon svg-icon-1">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                          fill="currentColor" />
                    <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                          fill="currentColor" />
                  </svg>
                </span>
            </div>
          </div>
          <div class="modal-body">
           
            <div class="row align-items-center">
              <div class="col-12 col-md-2 col-lg-2">
                <h4>{{$t('mail.a')}} <span class="text-danger">*</span></h4>
              </div>
              <div class="col-12 col-md-8 col-lg-8">
                <TagInput
                    containerClass="form-group mb-5"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    v-model="formDataUpdate.to"
                    :name="`to`"
                    :parent-id="'#'+id"
                    :helper-text="$t('invoice.help_mail_tag')"
                    :existingTags="contactSuggestions"
                    :includeSelectedTags="true"
                    :closeOnSelect="true"
                    :is-required="true"
                  />
               
              </div>

              <div class="col-12 col-md-1 col-lg-1" v-if="!showUpdateCc">
                <div class="d-flex align-items-center">
                  <i class="fa fa-plus-circle fs-4 me-3" @click="showUpdateCc = !showUpdateCc" style="color: #303D4E;"></i>
                  <h5 class="mt-1">{{$t('mail.cc')}}</h5>
                </div>
              </div>

              <div class="col-12 col-md-1 col-lg-1" v-if="!showUpdateCci">
                <div class="d-flex align-items-center">
                  <i class="fa fa-plus-circle fs-4 me-3" @click="showUpdateCci = !showUpdateCci" style="color: #303D4E;"></i>
                  <h5 class="mt-1">CCi</h5>
                </div>
              </div>
            </div>

            <div class="row align-items-center" v-if="showUpdateCc">
              <div class="col-12 col-md-2 col-lg-2">
                  <h4>{{$t('mail.cc')}} <i class="fa fa-minus-circle fs-4 ms-3" @click="showUpdateCc = !showUpdateCc" style="color: #303D4E;"></i></h4>
              </div>
              <div class="col-12 col-md-10 col-lg-10">
                <TagInput
                  containerClass="form-group mb-5"
                  type="email"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  v-model="formDataUpdate.cc"
                  :parent-id="'#'+id"
                  :name="`${id}-cc`"
                  :helper-text="$t('invoice.help_mail_tag')"
                />
              </div>
            </div>

            <div class="row align-items-center" v-if="showUpdateCci">
              <div class="col-12 col-md-2 col-lg-2">
                  <h4>CCi <i class="fa fa-minus-circle fs-4 ms-3" @click="showUpdateCci = !showUpdateCci" style="color: #303D4E;"></i></h4>
              </div>
              <div class="col-12 col-md-10 col-lg-10">
                <TagInput
                  containerClass="form-group mb-5"
                  type="email"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  v-model="formDataUpdate.bcc"
                  :parent-id="'#'+id"
                  :name="`${id}-bcc`"
                  :helper-text="$t('invoice.help_mail_tag')"
                />
              </div>
            </div>

            <div class="row align-items-center justify-content-center border-bottom">
                <div class="col-12 col-md-2 col-lg-2">
                    <h4>{{$t('mail.subject')}} <span class="text-danger">*</span></h4>
                </div>
                <div class="col-12 col-md-6 col-lg-6">
                  <Input
                    container-class="form-group mb-5"
                    :name="`subject`+ id"
                    type="text"
                    :inputClass="'form-control form-control-lg form-control-solid'"
                    size="lg"
                    v-model="formDataUpdate.subject"
                  />
                </div>
                <div class="col-12 col-md-4 col-lg-4" style="margin-top: -20px !important;">
                  <InputDate
                    v-if="route.query.tab === 'schedule'"
                    :name="'date'"
                    type="text"
                    :label="$t('mail.choose_date')"
                    labelClass="form-label fs-6 text-black"
                    :inputClass="'form-control form-control-sm form-control-solid'"
                    :isRequired="true" 
                    size="lg"
                    placeholder="d-m-Y H:i"
                    containerClass="form-group mb-5"
                    dateFormat="d-m-Y H:i"
                    :enableTime="true"
                    v-model="formDataUpdate.scheduled_at"
                    :enablePassTime="false"
                    :clearable="true"
                  />
                </div>   
            </div>
            
            <div class="row mt-5">
                <div class="col-12 col-md-9 col-lg-9">
                    <CKEditor
                      :id="'mail-editor-update'+id"
                      container-class="h-400px"
                      :content="formDataUpdate.message"
                      @text="getDescription"
                      ref="ckeditor"
                      @ready="onEditorReady"
                      :parent-id="'#'+id"
                    />
                </div>
                <div class="col-12 col-md-3 col-lg-3">
                  <div class="card border_style">
                    <div class="card-header">
                      <div class="d-flex align-items-center">
                        <h2>{{$t('pipelines.attach_files')}}</h2>
                        <span class="badge badge-light-warning fs-2 mb-2 ms-3">{{fileCount}}</span>
                      </div>
                    </div>
                    <div class="card-body p-5">
                      <div style="overflow-y: auto; max-height: 280px !important;">
                        <DropFileZone
                            :id="`${id}_upload_file3`"
                            :files="formDataUpdate.attach_files"
                            @addFiles="addFiles"
                            @removeFiles="removeFile"
                        />
                      </div> 
                    </div>
                  </div>
                </div>
            </div>
           <br>
            <ul class="nav nav-tabs nav-line-tabs nav-line-tabs-2x mb-5 fs-6 mt-20">
              <li class="nav-item">
                  <a class="nav-link active" data-bs-toggle="tab" :href="'#kt_settings_'+id">{{ $t("menu.settings") }}</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" data-bs-toggle="tab" :href="'#kt_signature_'+id">{{ $t("menu.signature") }}</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" :id="'kt_settings_'+id" role="tabpanel">
                <div class="d-flex align-items-center gap-4">
                  <div class="form-check me-5 mt-2">
                    <input class="form-check-input" type="checkbox" v-model="formDataUpdate.request_receipt" id="flexCheckDefault"/>
                    <label class="ms-2 form-label fs-6 text-black" for="flexCheckDefault">
                      {{ $t('mail.request_receipt') }}
                    </label>
                  </div>
                  <div class="d-flex align-items-center gap-3 mt-1">
                    <span class="me-2 form-label fs-6 text-black mt-1">{{ $t('mail.priority') }}</span>
                    <Select2
                      :parent-id="`#${id}`"
                      containerClass="col-12"
                      :name="`${id}-update_priority`"
                      :multiple="false"
                      selectClass="form-select-sm form-select-solid form-control-sm"
                      :isRequired="false"
                      :placeholderText="$t('mail.priority')"
                      v-model="formDataUpdate.priority"
                    >
                      <option v-for="(priority, index) in updatePriorities" :key="index" :value="priority.value">
                        {{ priority[locale] }}
                      </option>
                    </Select2>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" :id="'kt_signature_'+id" role="tabpanel">
                <div class="d-flex align-items-center gap-3">
                  <span class="me-2 form-label fs-6 text-black">{{ $t('menu.select_signature') }}</span>
                  <Select2
                    :parent-id="`#${id}`"
                    containerClass="col-6"
                    :name="`${id}-signature`"
                    :multiple="false"
                    selectClass="form-select-sm form-select-solid form-control-sm"
                    :isRequired="false"
                    :placeholderText="$t('menu.select_signature')"
                    v-model="selectedSignature"
                    :IsInputGroup="true"
                    icon="bi bi-plus"
                    :clickAddon="openSignatureModal"
                    :clear="true"
                  >
                    <option v-for="(signature, index) in signatures" :key="index" :value="signature.id">
                      {{ signature.name }}
                    </option>
                  </Select2>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-20">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="loadForm"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.send" size="7px 30px" :is-loading="isLoadingUpdate"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <SignatureModal id="create_signature_modal" @load="loadData" :parent="id"/>
</template>

<script setup>
  import {ref, defineEmits, defineProps, watch, computed, onMounted} from "vue";
  import Input from "@/components/Input.vue";
  import {useStore} from "vuex";
  import Button from "@/components/Button.vue"
  import RequiredText from "@/components/RequiredText.vue";
  import CKEditor from '@/components/CKEditor.vue';
  import TagInput from "@/components/TagifyInput.vue";
  import Select2 from "@/components/Select2";
  import {useLocales} from "@/composables/locales";
  import SignatureModal from "./SignatureModal.vue"
  import { useRoute } from "vue-router";
  import InputDate from "@/components/InputDate.vue"
  import DropFileZone from "@/components/DropFileZone.vue";
  import { $formatToYmdHi } from "@/mixins/Helpers";
  import mailConst from "@/composables/mailConst";

  const store = useStore()
  const {locale} = useLocales()
  const route = useRoute()

  const props = defineProps({
    id: {
      type: String,
      required: true
    },
    form: {
      type: Object,
      default: {
        to: [],
        cc: [],
        bcc: [],
        subject: '',
        message: '',
        attachments: [],
        email_id: '',
        scheduled_at: '',
        priority: '3 (Normal)',
        request_receipt: false,
        folder: '',
        attach_files: [],
        removed_attachments: [],
        is_draft: false
      }
    }
  })
  const emits = defineEmits(['load', 'edit'])

  const isLoadingUpdate = ref(false)
  const showUpdateCc = ref(false)
  const showUpdateCci = ref(false)
  const selectedSignature = ref('')
  const oldSelectedSignature = ref('')
  const ckeditor = ref(null)

  const formDataUpdate = ref(props.form)
  const contacts = computed(() => store.getters['mails/getUserContacts'])
  const updatePriorities = computed(() => store.getters['mails/getPriorities'])
  const contactSuggestions = computed(() => {
    return contacts.value
      ?.filter(item => item.email)
      .map(item => {
        return `${item.fullname} <${item.email}>`;
      }) || [];
  });
  const activeSignature = computed(() => store.getters['mails/getActiveSignature'])
  const signatures = computed(() => store.getters['mails/getSignatures'])
  const fileCount = computed(() => formDataUpdate.value.attachments?.length || 0)
  const removeElt = computed(() => {
    return signatures.value?.find(item => item.id === oldSelectedSignature.value);
  }); 
  const isUpdateDraft = computed(() => {
    if (ckeditor.value && ckeditor.value.editorInstance) {
      const editor = ckeditor.value.editorInstance
      const data = editor.getData().trim()
      const signatureHtml = `<p style="text-align: right;">${activeSignature.value?.content || ''}</p>`.trim()

      const parser = new DOMParser()
      const docContent = parser.parseFromString(data, 'text/html').body.textContent?.trim()
      const docSignature = parser.parseFromString(signatureHtml, 'text/html').body.textContent?.trim()

      if (docContent && docContent !== '' && docContent !== docSignature) {
        return true
      }

      return false
    }
  })

  watch(() => props.form, (value) => {
    if(value) {
      if(value.cc.length > 0) {
        showUpdateCc.value = true
      }else {
        showUpdateCc.value = false
      }
      if(value.bcc.length > 0) {
        showUpdateCci.value = true
      }else {
        showUpdateCci.value = false
      }
      formDataUpdate.value = JSON.parse(JSON.stringify(value))
    }
  }, { deep: true });

  function getDescription(text) {
    formDataUpdate.value.message = text
  }

  function addFiles(files) {
    for(let file of files) {
      formDataUpdate.value.attachments.push(file)
      formDataUpdate.value.attach_files.push(file)
    }
  }

  function removeFile(index) {
      const fileToDelete = formDataUpdate.value.attach_files.splice(index, 1)
      formDataUpdate.value.removed_attachments?.push(fileToDelete[0]?.id)
      formDataUpdate.value.attachments.splice(index, 1)
  }

  watch(() => activeSignature.value, (value) => {
    if(value) {
      selectedSignature.value = activeSignature.value.id
    }
  });

  watch(() => selectedSignature.value, (newVal, oldVal) => {
    if (newVal !== oldVal) {
      oldSelectedSignature.value = oldVal;
      if (oldSelectedSignature.value && removeElt.value) {
        removeSignature(removeElt.value.content);
      }
      if(newVal){
        changeSignature();
      }
    }
  });

  function changeSignature() {
    if(selectedSignature.value) {
      store.dispatch('mails/selectSignature', selectedSignature.value).then((response) => {
        store.dispatch('mails/loadActiveSignatures').then((res) => {
          insertSignature(activeSignature.value?.content)
          removeEmptyParagraphs()
        })
      })
    }
  }

  function openSignatureModal(){
    closeModal()
    $('#create_signature_modal').modal('toggle')
  }

  function onEditorReady(editor) {
    ckeditor.value.editorInstance = editor;
  }

  function insertSignature(variableText) {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;

    const htmlSignature = `<p style="text-align: right;">${variableText}</p>`;

    const viewFragment = editor.data.processor.toView(htmlSignature);
    const modelFragment = editor.data.toModel(viewFragment);

    editor.model.change(writer => {
      const root = editor.model.document.getRoot();
      const endPosition = editor.model.createPositionAt(root, 'end');

      const emptyParagraph = writer.createElement('paragraph');
      editor.model.insertContent(emptyParagraph, endPosition);

      const newEndPosition = editor.model.createPositionAt(root, 'end');

      editor.model.insertContent(modelFragment, newEndPosition);

      writer.setSelection(editor.model.createPositionAt(root, 'end'));
    });

  }

  function removeSignature(variableText) {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;
    const model = editor.model;

    const viewFragment = editor.data.processor.toView(variableText);
    const modelFragment = editor.data.toModel(viewFragment);

    model.change(writer => {
      const root = model.document.getRoot();
      const range = model.createRangeIn(root);

      const elementsToRemove = Array.from(modelFragment.getChildren());

      for (const element of elementsToRemove) {
        for (const item of range.getItems()) {
          if (item.is('element') && item.name === element.name) {
            const itemData = item.getChild(0)?.data?.trim();
            const elementData = element.getChild(0)?.data?.trim();

            if (itemData === elementData) {
              writer.remove(item);
              break;
            }
          }
        }
      }
    });
  }

  function clearEditorContent() {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;

    editor.model.change(writer => {
      const root = editor.model.document.getRoot();

      for (const child of Array.from(root.getChildren())) {
        writer.remove(child);
      }

      const emptyParagraph = writer.createElement('paragraph');
      writer.insert(emptyParagraph, root, 'end');
      writer.setSelection(emptyParagraph, 'in');
    });
  }

  function removeEmptyParagraphs() {
    if (!ckeditor.value || !ckeditor.value.editorInstance) return;

    const editor = ckeditor.value.editorInstance;
    const model = editor.model;
    const root = model.document.getRoot();

    model.change(writer => {
      const paragraphs = Array.from(root.getChildren()).filter(item =>
        item.is('element', 'paragraph')
      );

      for (const paragraph of paragraphs) {
        const textContent = Array.from(paragraph.getChildren())
          .map(child => child.data?.trim())
          .join('');

        if (!textContent || textContent === '\u00A0') {
          writer.remove(paragraph);
        }
      }
    });
  }

  function closeModal(){
    $('#'+props.id).modal('toggle')
    emits('edit', false)
    showUpdateCc.value = false
    showUpdateCci.value = false
  }

  function loadForm() {
    if(route.query.tab !== 'schedule') {
      closeModal()
      submitForm(true)
    }else{
      closeModal()
      resetForm()
      clearEditorContent()
      changeSignature()
    }
  }

  function resetForm() {
    formDataUpdate.value.to = []
    formDataUpdate.value.subject = ''
    formDataUpdate.value.message = ''
    formDataUpdate.value.cc = []
    formDataUpdate.value.bcc = []
    formDataUpdate.value.attachments = []
    formDataUpdate.value.newAttachments = []
    formDataUpdate.value.email_id = ''
    formDataUpdate.value.scheduled_at = ''
    formDataUpdate.value.priority = '3 (Normal)'
    formDataUpdate.value.request_receipt = false
    formDataUpdate.value.folder = route.query.tab
    formDataUpdate.value.is_draft = false
  }

  function formatArray(items){
    let data = []
    items.forEach(item => {
      const emailMatch = item.match(/<([^>]+)>/)
      if (emailMatch) {
        data.push(emailMatch[1])
      }else{
        data.push(item)
      }
    })
    return data
  }

  async function submitForm(draft= false){
    if(draft) formDataUpdate.value.is_draft = draft
    try {
      isLoadingUpdate.value = true;
      emits('edit', true)
      let content = {
        ...formDataUpdate.value,
        scheduled_at: formDataUpdate.value.scheduled_at ? $formatToYmdHi(formDataUpdate.value.scheduled_at) : moment().add(2, 'hours').format('YYYY-MM-DD HH:mm'),
        to: formatArray(formDataUpdate.value.to),
        cc: formatArray(formDataUpdate.value.cc),
        bcc: formatArray(formDataUpdate.value.bcc)
      }
      let data = route.query.tab !== 'schedule'
          ? { email_id: formDataUpdate.value.email_id, is_draft: draft, overrides: content}
          : content
      const endpoint = route.query.tab === 'schedule' ? 'mails/updateMail' : 'mails/updateDraftMail'
      await store.dispatch(endpoint, data).then((res) =>{
        if (!draft || (route.query.tab !== mailConst.DRAFT)) {
          emits('load');
        }
        if(!draft) window.toastr['success'](i18n.global.t('mail.update_successfully'))
        emits('edit', false)
      }).finally(() => {
        isLoadingUpdate.value = false;
        emits('edit', false)
      }) 
    } catch (error) {
      emits('edit', false)
    }
  }

  function sendMail() {
    Promise.all([submitForm(false)])
        .then(() => closeModal())
  }

  function loadData() {
    store.dispatch('mails/loadSignatures')
    store.dispatch('mails/loadActiveSignatures')
  }

  onMounted(() => {
    loadData()
    formDataUpdate.value = JSON.parse(JSON.stringify(props.form))
  })
</script>
    
<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }

  .border_style {
    border: 2px solid var(--bs-light)
  }

  .modal-dialog,
.modal-content {
  overflow: visible !important;
}
  .modal-content {
    overflow-x: auto;
  }

  .modal-body {
    min-width: 700px;
  }
</style>